import { FaFileDownload } from '@meronex/icons/fa';
import React, { memo } from 'react';
import { spacing, Box, Link } from '@apia/theme';
import config from '../../../../../config/dev';
import { TResponsiveTableCellRenderer } from '../../../../common/generic/responsiveTable/types';

export const DocumentRenderer: TResponsiveTableCellRenderer = memo(
  ({ cell }) => {
    return (
      <Link
        href={cell.rendererProps?.value as string}
        sx={React.useMemo(
          () => ({
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: spacing(2),
            color: 'primary',
            ':hover': (theme) => {
              return {
                color: theme.palette.lightenColor('primary', 30),
              };
            },
            justifyContent: 'center',
            width: '100%',
          }),
          [],
        )}
        target="_blank"
        title={config.BTN_FILE_DOWNLOAD_LBL}
        className="documentLink"
        rel="noreferrer"
        onClick={(ev) => {
          ev.stopPropagation();
        }}
      >
        <>
          <FaFileDownload size="25" />
          {cell?.rendererProps?.name && (cell.rendererProps.name as string)}
        </>
      </Link>
    );
  },
);
DocumentRenderer.displayName = 'DocumentRenderer';

export const HTMLRenderer: TResponsiveTableCellRenderer = memo(
  ({ cell, column, row, ...props }) => {
    if (typeof cell.rendererProps?.value === 'string') {
      return (
        <Box
          className="htmlCellRender"
          {...props}
          as="div"
          dangerouslySetInnerHTML={{
            __html: (cell.rendererProps?.value ?? '')
              .replaceAll('&amp;', '&')
              .replaceAll('&gt;', '>')
              .replaceAll('&lt;', '<')
              .replaceAll('&quot;', '"')
              .replaceAll('&apos;', "'"),
          }}
        />
      );
    }
    return <Box>Wrong HTML</Box>;
  },
);

HTMLRenderer.displayName = 'HTMLRenderer';
